var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "max-w-xl flex flex-col gap-6 m-auto" },
    [
      _c("ChargebackSearch", {
        attrs: { status: _vm.status, transactionId: _vm.transactionId },
        on: {
          searchClick: _vm.searchClick,
          refreshClick: _vm.fetchWithParams,
          selectedStatus: _vm.fetchWithParams,
        },
      }),
      _vm.shouldDisplayDueChargebacks ? _c("DueChargebacks") : _vm._e(),
      _c("ChargebackList", {
        on: { pageHandler: _vm.pageHandlerChargebackList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }